export default {
  path: 'logout',
  name: 'logout',
  component: () => import('../views/pages/Login/Logout.page.vue'),
  meta: {
    requiresAuth: false
  }
}
